// import logo from './logo.svg';
import '@fortawesome/fontawesome-free/css/all.min.css';

// import './App.css';
// import NavBar from './components/NavBar';
import Hero from '../components/Hero';
import Product from '../components/Product';
import Footer from '../components/Footer';


function HomePage() {
  return (
    <div className="App">
      <Hero/>
      <Product/>
      <Footer/>
    </div>
  );
}

export default HomePage;
